import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../Button/Button";

export default function ToggleButton({
  loginButtonText,
  loginButtonGradient,
  signupButtonText,
  signupButtonGradient,
  signupTextColor,
  signupBorder,
  signupPadding,
  loginUrl,
  signupUrl,
}) {
  // Dynamic navigation data
  const navData = [
    {
      id: 123,
      title: "هاست",
      children: [
        {
          id: 1,
          type: "server",
          mainName: "دایرکت ادمین",
          name: "هاست اقتصادی",
          image: "/images/directadmin.png",
          slug: "economy-directadmin-hosting",
          secondName: "هاست پیشرفته",
          thirdName: "نمایندگی هاست",
          secondSlug: "advanced-directadmin-hosting",
          thirdSlug: "directadmin-reseller-hosting",
        },
        {
          id: 2,
          type: "server",
          mainName: "سی پنل",
          name: "هاست اقتصادی",
          image: "/images/CPanel-PNG-Cutout.png",
          slug: "economy-cpanel-hosting",
          secondName: "هاست پیشرفته",
          thirdName: "نمایندگی هاست",
          secondSlug: "advanced-cpanel-hosting",
          thirdSlug: "cpanel-reseller-hosting",
        },
        {
          id: 3,
          type: "server",
          mainName: "پلسک",
          name: "هاست اقتصادی",
          image: "/images/plesk.png",
          slug: "economy-plesk-hosting",
          secondName: "هاست پیشرفته",
          thirdName: "نمایندگی هاست",
          secondSlug: "advanced-plesk-hosting",
          thirdSlug: "plesk-reseller-hosting",
        },
      ],
    },
    {
      id: 124,
      title: "سرور ",
      children: [
        {
          id: 1,
          mainName: "سرور ها",
          image: "/images/database-storage.png",
          type: "server",
          name: "مجازی",
          secondName: "مجازی پیشرفته",
          thirdName: "اختصاصی",
          slug: "virtual-server",
          secondSlug: "advanced-virtual-server",
          thirdSlug: "iran-dedicated-server",
        },
        {
          id: 2,
          mainName: "سرویس های ابری",
          image: "/images/cloud-computing (2).png",
          type: "server",
          name: "OVH",
          secondName: "Hetzner",
          fourthName: "سرور ابری ایران",
          slug: "ovh-international-cloud-server",
          secondSlug: "hetzner-international-cloud-server",
          fourthSlug: "iran-cloud-server",
        },
      ],
    },
    {
      id: 125,
      title: "دامنه",
      children: [],
    },
    {
      id: 126,
      title: "خدمات",
      children: [
        {
          id: 1,
          mainName: "سرویس های ویژه",
          image: "/images/digital-services(1).png",
          type: "server",
          name: "Big Blue Button",
          secondName: "مودل",
          fourthName: "ترید",
          fifthName: "طراحی سایت",
          sixthName: "گیت لب",
          seventhName: "سرویس پیامک انبوه",
          slug: "bigbluebutton-service",
          secondSlug: "advanced-moodle-services",
          fourthSlug: "sroys-tryd",
          fifthSlug:
            "https://crm.spadserver.com/submitticket.php?step=2&deptid=8",
          sixthSlug: "gitlab-service",
          seventhSlug: "bulk-sms-system"
        },
        {
          id: 2,
          mainName: "خدمات اینترنتی",
          image: "/images/protection.png",
          type: "server",
          name: "سرویس بکاپ",
          secondName: "گواهینامه SSL",
          thirdName: "لایسنس",
          slug: "backup-service",
          secondSlug: "ssl-certificate",
          thirdSlug: "licenses",
        },
      ],
    },
    {
      id: 126,
      title: "پایگاه دانش",
      children: [],
    },
    {
      id: 126,
      title: "ارتباط با ما",
      children: [
        {
          id: 1,
          mainName: "ارتباط با ما",
          image: "/images/call-center.png",
          type: "server",
          name: "درباره ما",
          contactNameOne: "مشتریان ما",
          contactNameTwo: "ارتباط با ما",
          thirdName: "ارسال تیکت",
          slug: "aboutus",
          contactSlugOne: "our-customers",
          thirdSlug: "https://Crm.spadserver.com/submitticket.php",
          contactSlugTwo: "contact",
        },
      ],
    },
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openTitle, setOpenTitle] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    setIsMenuOpen(false); // Close the menu if it's open
  };

  const toggleTitle = (title) => {
    if (title === "دامنه") {
      window.location.href = "/domain"; // Navigate to domain page
    } else if (title === "پایگاه دانش") {
      window.location.href = "https://spadserver.com/blog/"; // Navigate to blog page
    } else {
      setOpenTitle((prev) => (prev === title ? null : title));
      setIsDropdownOpen(false); // Close dropdown if a title is clicked
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Items that should not have 'product/' prefix
  const noHostPrefix = ["دامنه", "درباره اسپاد", "مشتریان ما", "ارتباط با ما"];

  return (
    <div className="font-main bg-custom-gradient border-b-2 border-border">
      <div className="flex justify-between items-center p-4 mx-4 md:mx-10">
        <a href="/">
          <img src="/images/newLogo.png" className="w-16" alt="Logo" />
        </a>

        <div className="wrapper-button flex">
          <button
            className="block md:hidden text-white focus:outline-none ml-4"
            onClick={toggleDropdown}
          >
            <img src="../../../images/login.png" alt="" />
          </button>

          <button
            className="block md:hidden text-white"
            onClick={() => {
              setIsMenuOpen((prev) => !prev);
              setIsDropdownOpen(false); // Close dropdown if menu is opened
            }}
          >
            <img src="../../../images/menu.png" alt="Menu" />
          </button>

          <div
            className={`absolute top-20 left-2 mt-2 text-black shadow-lg rounded-md overflow-hidden transition-opacity duration-300 ${
              isDropdownOpen ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <div className="p-4 space-y-2">
              <a href={loginUrl} className="ml-[5px]">
                <Button
                  text={loginButtonText}
                  gradient={loginButtonGradient}
                  className="w-full py-1 text-xs"
                />
              </a>
              <a href={signupUrl}>
                <Button
                  text={signupButtonText}
                  gradient={signupButtonGradient}
                  textColor={signupTextColor}
                  border={signupBorder}
                  padding={signupPadding}
                  className="w-full py-1 text-xs"
                />
              </a>
            </div>
          </div>
        </div>

        {/* <div className="hidden md:flex items-center text-white font-semibold w-full justify-center">
          {navData.map(({ title, children }) => (
            <div
              key={title}
              className="relative group mx-4 cursor-pointer"
              onClick={() => toggleTitle(title)}
            >
              <div className="hostLink cursor-pointer text-center">{title}</div>
              {openTitle === title && (
                <div className="navbarSubMenu absolute z-10 top-full left-0 w-64 bg-white p-4 shadow-lg">
                  {children.map((item) => {
                    const slugPrefix =
                      item.slug &&
                      !item.slug.startsWith("http") &&
                      !noHostPrefix.includes(title)
                        ? `product/${item.slug}`
                        : item.slug;

                    return (
                      <div key={item.id}>
                        <p className="text-gray-700 text-sm font-medium border-b border-gray-300 pb-2">
                          {item.mainName}
                        </p>
                        <ul>
                          <li>
                            <Link
                              to={`/${slugPrefix}`}
                              className="text-black block font-medium px-2 py-1 rounded-md"
                              onClick={closeMenu}
                            >
                              {item.name}
                            </Link>
                          </li>
                          {item.secondSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.secondSlug.startsWith("http")
                                    ? item.secondSlug
                                    : `product/${item.secondSlug}`
                                }`}
                                className="text-black block font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.secondName}
                              </Link>
                            </li>
                          )}
                          {item.thirdSlug && (
                            <li>
                              <Link
                                to={`/${slugPrefix}`}
                                className="text-black block font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.thirdName}
                              </Link>
                            </li>
                          )}
                          {item.fourthSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.fourthSlug.startsWith("http")
                                    ? item.fourthSlug
                                    : `product/${item.fourthSlug}`
                                }`}
                                className="text-black block font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.fourthName}
                              </Link>
                            </li>
                          )}
                          {item.fifthSlug && (
                            <li>
                              <a
                                href={item.fifthSlug}
                                className="text-black block font-medium px-2 py-1 rounded-md"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMenu}
                              >
                                {item.fifthName}
                              </a>
                            </li>
                          )}
                          {item.sixthSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.fourthSlug.startsWith("http")
                                    ? item.fourthSlug
                                    : `product/${item.fourthSlug}`
                                }`}
                                className="text-black block font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.fourthName}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div> */}

        <div className="hidden md:flex space-x-4">
          <a href={loginUrl}>
            <Button text={loginButtonText} gradient={loginButtonGradient} />
          </a>
          <a href={signupUrl}>
            <Button
              text={signupButtonText}
              gradient={signupButtonGradient}
              textColor={signupTextColor}
              border={signupBorder}
              padding={signupPadding}
            />
          </a>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden text-white font-semibold bg-custom-gradient">
          {navData.map(({ title, children }) => (
            <div key={title} className="px-4 py-2">
              <div
                className="hostLink cursor-pointer text-center"
                onClick={() => toggleTitle(title)}
              >
                {title}
              </div>
              {openTitle === title && (
                <div className="pl-4">
                  {children.map((item) => {
                    const slugPrefix =
                      item.slug &&
                      !item.slug.startsWith("http") &&
                      !noHostPrefix.includes(title)
                        ? `product/${item.slug}`
                        : item.slug;

                    return (
                      <div key={item.id}>
                        <p className="text-gray-200 text-sm font-[14px] border-b border-gray-700 pb-2">
                          {item.mainName}
                        </p>
                        <ul className="pt-1 pb-4">
                          <li>
                            <Link
                              to={`/${slugPrefix}`}
                              className="text-white block text-[10px] px-2 hover:bg-blue-400 hover:text-black py-1 rounded-md"
                              onClick={closeMenu}
                            >
                              {item.name}
                            </Link>
                          </li>
                          {item.secondSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.secondSlug.startsWith("http")
                                    ? item.secondSlug
                                    : `product/${item.secondSlug}`
                                }`}
                                className="text-white hover:bg-blue-400 hover:text-black text-[10px] block px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.secondName}
                              </Link>
                            </li>
                          )}
                          {item.contactSlugOne && (
                            <li>
                              <Link
                                to={`/${
                                  item.contactSlugOne.startsWith("http")
                                    ? item.contactSlugOne
                                    : `${item.contactSlugOne}`
                                }`}
                                className="text-white hover:bg-blue-400 hover:text-black text-[10px] block px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.contactNameOne}
                              </Link>
                            </li>
                          )}
                          {item.contactSlugTwo && (
                            <li>
                              <Link
                                to={`/${
                                  item.contactSlugTwo.startsWith("http")
                                    ? item.contactSlugTwo
                                    : `${item.contactSlugTwo}`
                                }`}
                                className="text-white hover:bg-blue-400 hover:text-black text-[10px] block px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.contactNameTwo}
                              </Link>
                            </li>
                          )}
                          {item.thirdSlug && (
                            <li>
                              <a
                                href={item.thirdSlug}
                                className="text-white text-[12px] hover:bg-blue-400 hover:text-black block font-medium px-2 py-1 rounded-md"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMenu}
                              >
                                {item.thirdName}
                              </a>
                            </li>
                          )}
                          {item.fourthSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.fourthSlug.startsWith("http")
                                    ? item.fourthSlug
                                    : `product/${item.fourthSlug}`
                                }`}
                                className="text-white block text-[12px] hover:bg-blue-400 hover:text-black font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.fourthName}
                              </Link>
                            </li>
                          )}
                          {item.fifthSlug && (
                            <li>
                              <a
                                href={item.fifthSlug}
                                className="text-white text-[12px] hover:bg-blue-400 block font-medium px-2 py-1 rounded-md"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMenu}
                              >
                                {item.fifthName}
                              </a>
                            </li>
                          )}
                          {item.sixthSlug && (
                            <li>
                              <Link
                                to={`/${
                                  item.sixthSlug.startsWith("http")
                                    ? item.sixthSlug
                                    : `product/${item.sixthSlug}`
                                }`}
                                className="text-white block text-[12px] hover:bg-blue-400 hover:text-black font-medium px-2 py-1 rounded-md"
                                onClick={closeMenu}
                              >
                                {item.sixthName}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
